module.exports = new __parcel__URL__("gooh_refinery_level_2_v2.92ef634b.png").toString();